export default __webpack_public_path__ + "static/media/upload.40df4348.svg";